import audioSrcs from "url:./audio/ui/*";
import * as content from "./content.json";
import { Howl, Howler } from "howler/src/howler.core";

const FADE_DURATION_MS = 1000;

class UIAudio {
  private sounds: Map<string, Howl> = new Map();
  private currentSoundrack: Howl | null = null;

  constructor() {
    this.isMuted = true;
    Howler.autoSuspend = false;

    Object.keys(content.uiAudio).forEach((key) => {
      const data = content.uiAudio[key];
      this.sounds.set(
        key,
        new Howl({
          src: audioSrcs[`${data.src}.mp3`],
          loop: data.loop,
          html5: true,
          onfade: function () {
            if (this.volume === 0) {
              this.pause();
            }
          },
        })
      );
    });
  }

  public set isMuted(isMuted: boolean) {
    Howler.mute(isMuted);
  }

  public play(key: string, fadeIn?: boolean): void {
    if (!this.sounds.has(key)) return;
    const sound = this.sounds.get(key);
    const shouldFade = fadeIn === undefined ? sound.loop : fadeIn;
    if (shouldFade) {
      sound.fade(0, 1, FADE_DURATION_MS);
    }
    sound.play();
  }

  public playSoundtrack(key: string): void {
    if (!this.sounds.has(key)) return;
    const soundtrack = this.sounds.get(key);
    if (this.currentSoundrack === soundtrack) return;

    if (this.currentSoundrack) {
      this.currentSoundrack.fade(
        this.currentSoundrack.volume(),
        0,
        FADE_DURATION_MS
      );
    }
    soundtrack.pause();
    soundtrack.volume(0);
    soundtrack.fade(0, 1, FADE_DURATION_MS);
    soundtrack.play();
    this.currentSoundrack = soundtrack;
  }

  public stop(key: string, fadeOut?: boolean): void {
    if (!this.sounds.has(key)) return;
    const sound = this.sounds.get(key);
    const shouldFade = fadeOut === undefined ? sound.loop : fadeOut;
    if (shouldFade) {
      sound.onfade = () => {
        sound.onfade = null;
        sound.stop();
      };
      sound.fade(1, 0, FADE_DURATION_MS);
    } else {
      sound.stop();
    }
  }
}

export default UIAudio;
